import { useRouteLoaderData } from "react-router-dom";

export function useChoiceLabel(name, apiData) {
    let const_choices = {};
    if (apiData) {
        const_choices = apiData;
    } else {
        const commonInfo = useRouteLoaderData("commonInfo");
        const_choices = commonInfo.const_choices;
    }
    const cnst = const_choices[name];
    const res = {};
    Object.keys(cnst).forEach((k) => {
        res[cnst[k][0]] = cnst[k][1];
    });
    return res;
}

export const DEVELOPER_DEFAULT_ID = 201;
export const DEVELOPER_VKPLAY_GAMES_ID = 6342;
export const ADMIN_MODERATION = "moderate";
export const ADMIN_SUPPORT = "support";
export const VK_LIVE_ID_VKPLAYSTORE = "2829bb1c-f249-484b-8248-26f210b80e24";

export const GameType = {
    PARTNER: "partner",
    DOWNLOAD: "download",
    CODE: "code",
    PAID_CONTENT: "paid_content",
};

export const GameKeySource = {
    DEVAREA: "devarea",
};

export const GamePublicationState = {
    CONFIGURATION: "configuration",
    CONFIGURATION_MARKETING: "configuration_marketing",
    TESTING: "testing",
    TESTING_MARKETING: "testing_marketing",
    DONE: "done",
    UNPUBLISH_REQUEST: "unpublish_request",
    UNPUBLISHED: "unpublished",
};

export const GamePublicationWishlistState = {
    CONFIGURATION: "configuration",
    CONFIGURATION_MARKETING: "configuration_marketing",
    TESTING_MARKETING: "testing_marketing",
    DONE: "done",
};

export const GameFeatureFlags = {
    CLIENT: "client",
    CASUAL: "casual",
    BROWSER: "browser",
    MINI: "mini",
    DLC: "dlc",
    BUNDLE: "bundle",
    DEMO: "demo",
};

export const GameFeaturingLaunchManager = [
    "Ольга Самсонова",
    "Елизавета Розанцева",
    "Мария Якубовская",
    "Елизавета Храмова",
];

export const GameFeaturingLaunchState = {
    DRAFT: "draft",
    MODERATE: "moderate",
    REJECTED: "rejected",
    MARKETING_REVIEW: "marketing_review",
    REVIEW_PASSED: "review_passed",
    PROMO_LAUNCHED: "promo_launched",
    PROMO_COMPLETED: "promo_completed",
    REFUSED: "refused",
};

export const GameFeaturingPromoState = {
    NEW: "new",
    MODERATE: "moderate",
    POSTMODERATE: "postmoderate",
    APPROVED: "approved",
    REJECTED: "rejected",
    PUBLISHED: "published",
    FINISHED: "finished",
};

export const DeveloperState = {
    NEW: "new",
    APPROVED: "approved",
    REJECTED: "rejected",
};

export const DeveloperFinanceModeration = {
    NEW: "none",
    APPROVED: "approved",
    REJECTED: "rejected",
    ON_MODERATION: "on_moderation",
};

export const DeveloperLegalForm = {
    LEGAL: "legal",
    SELF: "self",
    PHYSICAL: "physical",
    INDIVIDUAL: "individual",
};

export const DeveloperEdoOperator = {
    DIADOK: "diadoc",
    OTHER: "other",
};

export const DeveloperIdDocumentType = {
    PASSPORT_RUSSIAN_FEDERATION: 1,
    PASSPORT_FOREIGN_CITIZEN: 2,
    PASSPORT_FOREIGN: 3,
    OTHER: 4,
};

export const DeveloperResidenceTerr = {
    VKP_RU: "vkp_ru",
    VKP_OTHER: "vkp_other",
};

export const DeveloperCountry = {
    RUS: 188,
    UAE: 30,
};

export const DeveloperCitizenship = {
    RUSSIA: "RUS",
};

export const GameRelationPurpose = {
    DLC: "dlc",
    HIDDEN_COMPONENT: "hidden_component",
    DLC_COMPONENT: "dlc_component",
};

export const GameRelationRelType = {
    LIST: "list",
    STAR: "star",
    FULL: "full",
};

export const BetatesterUploadState = {
    WAIT: "wait",
    WORK: "work",
    DONE: "done",
};

export const BetatesterUploadAction = {
    ADD: "add",
    DEL: "del",
};

export const GameRelationshipKind = {
    DLC_ITEM: "dlc_item",
    DLC_CONTENT: "dlc_content",
    DLC_HIDDEN: "dlc_hidden",
    BUNDLE_ADD_COLLECTION: "bundle_add_collection",
    BUNDLE_FULL_PRICE: "bundle_full_price",
    DEMO: "demo",
    ITEM_BUNDLE: "item_bundle",
};

export const GameStreamMode = {
    AUTO: "auto",
    MANUAL: "manual",
    COMBO: "combo",
};

export const GameCountryDraftState = {
    NEW: "new",
    LOCK: "lock",
    REJECTED: "rejected",
};

export const MarketSerialBatchState = {
    NEW: "new",
    APPROVED: "approved",
    REJECTED: "rejected",
    DONE: "done",
    TO_BAN: "to_ban",
    BANNED: "banned",
};

export const DeveloperLnkPublisherState = {
    ON_MODERATION: "on_moderation",
    APPROVED: "approved",
    REJECTED: "rejected",
};

export const GamePublisherState = {
    ON_MODERATION: "on_moderation",
    APPROVED: "approved",
    REJECTED: "rejected",
};

export const SteamGiftOrderState = {
    ORDERED: "ordered",
    PAYED: "payed",
    REFUND: "refund",
    DONE: "done",
};

export const SteamGiftOrderGiftState = {
    0: "NEW",
    1: "CREATED",
    2: "PENDING",
    3: "AWAIT_FRIEND",
    4: "AWAIT_PAYMENT",
    5: "AWAIT_ADD_PAYMENT",
    6: "GIFT_SENT",
    7: "SUCCESS",
    8: "FAIL",
    9: "BAD_LINK",
};

export const ModeratorLogKind = {
    SERVICE: "service",
    FROM_DEVELOPER: "from_developer",
    TO_DEVELOPER: "to_developer",
};

export const LandingBlockTypes = {
    banner: "Баннер в карточке игры",
    banner_on_landing: "Баннер на лендинге",
    header: "Заголовок (брендинг)",
    slider_horizontal: "Слайдер горизонтальный",
    slider_vertical: "Слайдер вертикальный",
    with_vertical_covers: "Блок с вертикальными обложками",
    mascot_collections: "Блок с маскотом",
    screenshots: "Блок со скриншотами",
    all_offers: "Блок все предложения",
    streams: "Блок стримов",
    promotion: "Блок акций",
    market: "Блок маркета",
};

export const moderationState = {
    material_request: "Запрос материалов",
    marketing_review: "Маркетинговое ревью",
    material_rejected: "Материалы отклонены",
    review_passed: "Ревью пройдено",
};

export const blockWithSettings = [
    "banner",
    "banner_on_landing",
    "header",
    "with_vertical_covers",
    "mascot_collections",
    "screenshots",
    "all_offers",
    "streams",
    "promotion",
    "market",
    "slider_horizontal",
    "slider_vertical",
];

export const developerDocumentState = {
    new: "Не создан",
    sent: "Подписать",
    checking: "На проверке",
    declined: "Отклонен",
    signed: "Подписан",
};

export const adminDocumentState = {
    new: "Не создан",
    sent: "Отправлен",
    checking: "На проверке",
    declined: "Отклонен",
    signed: "Подписан",
};

export const DeveloperProjectTransferStatus = {
    NEW: "new",
    HOLDER: "holder",
    REJECT_HOLDER: "reject_holder",
    MODER_FIN: "moder_fin",
    REJECT_FIN: "reject_fin",
    MODER_TECH: "moder_tech",
    REJECT_TECH: "reject_tech",
    APPROVED: "approved",
    DONE: "done",
};

export const DeveloperProjectTransferReason = {
    COPYRIGHT: "copyright",
    LICENSE: "license",
    TAX: "tax",
};

export const GameMicroReviewComplaintStatus = {
    NONE: "",
    REQUEST: "request",
    APPROVE: "approve",
    REJECT: "reject",
};

export const ActionLogAction = {
    CREATE: "create",
    UPDATE: "update",
    DELETE: "delete",
    CRUD: "crud",
    RECREATE: "recreate",
    CHANGE: "change",
    MISC: "misc",
    APK_UPLOAD: "apk_upload",
};

export const GameVisibilityState = {
    DEV: "dev",
    PAGE: "page",
    CATALOG: "catalog",
    ARCHIVED: "archived",
};

export const ASTRUM_DEVELOPER_IDS = [
    201, 219, 222, 254, 255, 256, 267, 269, 351, 405, 458, 730, 915, 967, 980, 983, 1320, 1329, 1411, 1461, 2308, 2433,
    2447, 2484, 2882, 5390,
];
